// src/services/aboutServices.js (FRONTEND - public site)
import api from "../api/api";

const ORIGIN = import.meta.env?.VITE_BACKEND_ORIGIN || "https://api.ifjona.com";

const toStorageUrl = (path) => {
  if (!path) return null;
  const s = String(path);

  if (s.startsWith("http://") || s.startsWith("https://")) return s;
  if (s.startsWith("/storage/")) return `${ORIGIN}${s}`;
  if (!s.startsWith("/")) return `${ORIGIN}/storage/${s}`;
  return `${ORIGIN}${s}`;
};

const normalizeAboutList = (res) => {
  const data = res?.data;
  let list = [];

  // supports: {data:[...]} OR [...]
  if (Array.isArray(data?.data)) list = data.data;
  else if (Array.isArray(data)) list = data;

  return (list || []).map((row) => ({
    ...row,

    // 👇 build absolute URLs for images/icons
    image_url: toStorageUrl(row.image_url || row.image),
    icon_url: toStorageUrl(row.icon_url || row.icon),
  }));
};

// ✅ your public endpoints
export const ABOUT_PUBLIC_ENDPOINTS = {
  hero: "/about/hero",
  values: "/about/values",
  team: "/about/team",
};

export const getAboutHeroes = async () => {
  const res = await api.get(ABOUT_PUBLIC_ENDPOINTS.hero);
  return normalizeAboutList(res);
};

export const getAboutValues = async () => {
  const res = await api.get(ABOUT_PUBLIC_ENDPOINTS.values);
  return normalizeAboutList(res);
};

export const getAboutTeamMembers = async () => {
  const res = await api.get(ABOUT_PUBLIC_ENDPOINTS.team);
  return normalizeAboutList(res);
};
